import React from "react";

export default function FaqCommon() {
    return (
        <div>
            <h1 className="md:text-5xl text-3xl font-bold text-center mb-8"><span className="text-blue-800">FAQs</span> about <span className="text-blue-800">Career</span> <span className="text-orange-400">Hikers</span></h1>
            <Common
                question="What is Career Hikers?"
                answer="The first and only platform in India that enables students to prepare for competitive tests like the IIT-JEE and NEET-UG, the CA foundation exam, the Gate exam, the UPSC exam, and other government exams is called Career Hikers. Interact immediately over the phone with the top mentors and counsellors. The mentors and counsellors are available for the candidates to speak with directly regarding the best preparation plan, board examinations, paper attempt strategy, reference books and study materials, coaching, handling exam stress, etc."
            />
            <Common
                question="What are the services provided to students by Career Hikers?"
                answer="Students may search for and connect directly with counsellors of their choosing career option using the platform offered by Career Hikers. The student can choose the day and time of the call from a list of booking slots."
            />
            <Common
                question="How can a student sign-up on Career Hikers?"
                answer="You can click on the sign-up button given in the application and fill in the basic details mentioned in the sign-up form. Once you verify the phone number, you will be registered as a user on the platform and you can book your call with us."
            />
            <Common
                question="Do you provide any coaching, test series or study material?"
                answer="Yes, we provide courses on the career building skills like digital marketing, GSOC, graphic designing, stock marketing etc."
            />
            <Common
                question="What is the Refund policy of Career Hikers?"
                answer="If you face any issues/problems with the service and would like a refund please write to us at help@careerhikers.com and our team will assist you further."
            />
            <Common
                question="Which Indian areas do we serve?"
                answer="All users in India are welcome to utilise Career Hikers."
            />
        </div>

    )
}

function Common(props) {
    return (
        <div className="collapse border-2 mx-4 md:mx-16">
            <input type="checkbox" />
            <div className="collapse-title text-lg md:text-xl font-medium">
                {props.question}
            </div>
            <div className="collapse-content md:text-base text-sm">
                <p>{props.answer}</p>
            </div>
        </div>
    )
}